import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterNodeData, QaBasicFilter } from "./qaTypes";

export const samQaSliceName = "samQa";

export interface SamQaState {
  basicFilter: QaBasicFilter;
}

const initialState: SamQaState = {
  basicFilter: {},
};

const samSlice = createSlice({
  name: samQaSliceName,
  initialState,
  reducers: {
    setQaBasicProjectStructureFilter(state: SamQaState, action: PayloadAction<FilterNodeData[]>) {
      state.basicFilter = { projectStructure: action.payload };
    },
    setQaBasicTemplateFilter(state: SamQaState, action: PayloadAction<FilterNodeData[]>) {
      state.basicFilter = { template: action.payload };
    },
    resetQaBasicFilter(state: SamQaState) {
      state.basicFilter = {};
    },
  },
});

export interface SamQaRootState {
  [samQaSliceName]: SamQaState;
}

export const selectSamQa = (state: SamQaRootState) => state[samQaSliceName];
export const selectSamQaBasicFilter = (state: SamQaRootState) => selectSamQa(state).basicFilter;

export const { setQaBasicProjectStructureFilter, setQaBasicTemplateFilter, resetQaBasicFilter } = samSlice.actions;
export const samQaReducer = samSlice.reducer;
